import { ElementRef, inject, Injectable, Renderer2 } from '@angular/core';
import {
  CompanySelection,
  ProfileSelectorDetails
} from '@com-delta-idp/mnx-capability-profile-selector-ui';

import { ActivatedRoute } from '@angular/router';
import { ProfileSelectorAdapterHelperService } from '../data-access/adapters/profile-selector-adapter-helper.service';
import {
  AEM_AIR_SHOPPING,
  AEM_CONTENT,
  AEM_STATICURL,
  BAU_URLS,
  DOT_DELTA_COM,
  HOME_PAGE_URL,
  PERM_TYPE,
  WIFI_PORTAL
} from '../data-access/constants/profile-selector-constants';
import { ProfileSelectorFacadeService } from '../data-access/facades/profile-selector-facade.service';
import { SwitchingAccountService } from '../data-access/services/switching-account/switching-account.service';
import { MachCoreModalUtilService } from '../data-access/utils/mach-core-modal-util.service';
import { ProfileSelectorUtilService } from '../data-access/utils/profile-selector-util.service';
@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorHelperComponent {
  refreshURL = '';
  formElement!: ElementRef;

  emptyContentDetails: ProfileSelectorDetails = {} as ProfileSelectorDetails;
  emptyBusinessStateSelected = {} as {
    selectedState: boolean;
    accountIndex: number;
  };

  profileSelectorFacadeService = inject(ProfileSelectorFacadeService);
  profileSelectorAdapterHelperService = inject(
    ProfileSelectorAdapterHelperService
  );

  profileSelectorUtilService = inject(ProfileSelectorUtilService);
  switchingAccount = inject(SwitchingAccountService);
  renderer = inject(Renderer2);
  elementRef = inject(ElementRef);
  route = inject(ActivatedRoute);

  machCoreModalUtilService = inject(MachCoreModalUtilService);
  hideModalOnSelect = false;

  defaultSelectAccount(
    companyName: string,
    permType: string,
    accountIndex: number
  ): void {
    const defaultSelection: CompanySelection = {
      permType: permType,
      companyName: companyName,
      accountIndex: accountIndex,
      corporateId: '',
      isOaSmeAccount: false,
      partnerId: '',
      restrictOnePax: false,
      displayInlineText: '',
      disableMiles: false
    };
    this.profileSelectorUtilService.setAccountCookie(defaultSelection);
  }

  selectAccount(params: CompanySelection): void {
    this.hideModalOnSelect = true;
    this.switchingAccount.updateCorporateName(params.companyName);
    this.profileSelectorFacadeService.accountSelected(params);
    this.profileSelectorFacadeService.storeCompanyId$.subscribe((value) => {
      if (value) {
        if (this.isRedirectForStandAloneHelper(params.permType)) {
          this.returnToOriginalPage();
        }
      }
    });
  }

  isRedirectForStandAloneHelper(permType: string): boolean {
    return (
      this.profileSelectorFacadeService.fromProfileStandAlone() &&
      permType !== PERM_TYPE.S &&
      permType !== PERM_TYPE.A
    );
  }

  returnToOriginalPage(): void {
    this.refreshURL = this.refreshURL || HOME_PAGE_URL;
    this.returnToRefreshURL();
  }

  getElementRefHelper(element: ElementRef): void {
    this.formElement = element;
  }

  returnToRefreshURL(): void {
    if (this.returnToOriginalUrl(this.refreshURL)) {
      this.formElement.nativeElement.submit();
    } else {
      window.location.href = this.refreshURL;
    }
  }

  returnToOriginalUrl(resUrl: string): boolean {
    let bauUrlCheck = false;
    let bauUrl = [];

    if (BAU_URLS) {
      bauUrl = BAU_URLS;
      bauUrl?.filter((item) => {
        if (resUrl && resUrl.includes(item)) {
          bauUrlCheck = true;
        }
      });
    }
    return bauUrlCheck;
  }

  refreshURLAvailable(): boolean {
    return (
      this.refreshURL.indexOf(AEM_CONTENT) !== -1 ||
      this.refreshURL.indexOf(AEM_STATICURL) !== -1 ||
      this.refreshURL.indexOf(AEM_AIR_SHOPPING) !== -1 ||
      this.checkForWifiUrl()
    );
  }

  checkForWifiUrl(): boolean {
    return (
      this.refreshURL?.includes(WIFI_PORTAL) &&
      this.refreshURL?.includes(DOT_DELTA_COM)
    );
  }

  modalContainerFocus(): void {
    const modalContainer = document.getElementById(
      'profile-selector-smart'
    ) as HTMLInputElement;
    if (modalContainer) {
      modalContainer.focus();
    }
  }
}
